import { MSEnum } from '@/common/enumeration';
class InvoiceUtils {
	/**
	 * Điều kiện để show tính năng kiểm tra lại(lấy lại thông tin chi tiết hàng hóa) của hóa đơn
	 * Kết nối CQT và hóa dơn được phép
	 */
	conditionShowUpdateInvoice(currentItem, getDataConnectTaxaxion, maximumNumberCickUpdate, isInbot = true) {
		const me = this;
		return (
			me.checkConnectTaxaxion(getDataConnectTaxaxion, isInbot) &&
			me.conditionInvoiceAllowUpdateDetail(currentItem) &&
			currentItem.NumberClickUpdateInvoiceDetails <= maximumNumberCickUpdate
		); // check số lần cập nhật chi tiết hóa đơn
	}

	/**
	 * Điều kiện hóa đơn được phép cập nhật lại chi tiết trên CQT
	 */
	conditionInvoiceAllowUpdateDetail(currentItem) {
		const me = this;
		return currentItem && currentItem.ConditionShowUpdateInvoice;
	}

	/**
	 *Kết nối CQT hay không
	 */
	checkConnectTaxaxion(getDataConnectTaxaxion, isInbot = true) {
		const me = this;
		return (
			getDataConnectTaxaxion &&
			getDataConnectTaxaxion.ConnectType == MSEnum.ConnectInvoiceEnum.Taxaxion &&
			getDataConnectTaxaxion.Status == MSEnum.ConnectInvoiceStatus.Success &&
			(isInbot ? getDataConnectTaxaxion.IsInbot : getDataConnectTaxaxion.IsOutbot)
		); //Check kết nối với CQT // Có kết nối với hóa đơn đầu vào hay không
	}
}

export default new InvoiceUtils();
